import { render } from "./InviteFriendsModal.vue?vue&type=template&id=d1889dfa&ts=true"
import script from "./InviteFriendsModal.vue?vue&type=script&lang=ts"
export * from "./InviteFriendsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__